// extracted by mini-css-extract-plugin
module.exports = {"scrollView":"ScrollView_scrollView__1CSBD"};